import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tipoServicio: [],
  },

  getters: {
    getTipoServicio: (state) => state.tipoServicio,
  },

  mutations: {
    SET_TIPO_SERVICIO(state, tipoServicio) {
      state.tipoServicio = tipoServicio;
    },
  },

  actions: {
    async fetchTipoServicio({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/cattipoServicio')
        .then((response) => {
          commit('SET_TIPO_SERVICIO', response.data.data);
        });
    },
  },
};
